export default __webpack_public_path__ + "static/media/inside-weather-dbH_vy7vICE-unsplash.b82f628b.png";